import {
    ACTIVITY_LIST, ACTIVITY_PROPOSAL, NEXT_ACTIVITY, CHECK_OPPORTUNITY_CLOSED_OR_DROPPED,
    VIEW_ACTIVITY, NEW_ACTIVITY, CANCEL_ACTIVITY, REJECT_ACTIVITY, DISTANCE_FROM_SITE,
    MAINTENANCE_COST, LEAD_GATE_TYPE, POST_CLOSURE, SELECTED_TAGGED_ALONG,
} from "./type";

const initialState = {
    activityList: [],
    nextActivity: [],
    proposalActivity: [],
    checkOpportunity: [],
    activityByIdDetails:[],
    saveNewActivity: [],
    cancelActivity: [],
    rejectActivity:[],
    distance:[],
    maintenanceCostDetails:[],
    leadGateTypes: [],
    postClosureDetails:[],
    selectedTaggedAlongResponse: [],
};

const Activity = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case ACTIVITY_LIST:
            return {
                ...state,
                activityList: payload,
            };
        case NEXT_ACTIVITY:
            return {
                ...state,
                nextActivity: payload,
            };
        case ACTIVITY_PROPOSAL:
            return {
                ...state,
                proposalActivity: payload,
            };
        case CHECK_OPPORTUNITY_CLOSED_OR_DROPPED:
            return {
                ...state,
                checkOpportunity: payload,
            };
        case VIEW_ACTIVITY:
            return {
                ...state,
                activityByIdDetails: payload,
            };
        case NEW_ACTIVITY:
            return {
                ...state,
                saveNewActivity: payload,
            };
        case CANCEL_ACTIVITY:
            return {
                ...state,
                cancelActivity: payload,
            };
        case REJECT_ACTIVITY:
            return {
                ...state,
                rejectActivity: payload,
            };
        case DISTANCE_FROM_SITE:
            return {
                ...state,
                distance: payload,
            };
        case MAINTENANCE_COST:
            return {
                ...state,
                maintenanceCostDetails: payload,
            };
        case LEAD_GATE_TYPE:
            return {
                ...state,
                leadGateTypes: payload,
            };
        case POST_CLOSURE:
            return {
                ...state,
                postClosureDetails: payload,
            };
        case SELECTED_TAGGED_ALONG:
            return {
                ...state,
                selectedTaggedAlongResponse: payload,
            };
        default:
            return {...state};
    }
};

export default Activity;